import { Tabs as MTabs, TabsProps } from '@mui/material'

export const Tabs: React.FC<TabsProps> = (props) => {
  return <MTabs {...props} />
}
